export class ProgressBar{
    constructor(){
        this.circleClass = 'checkmark__circle__red';
        this.checkClass = 'checkmark__fill__red';
    }
    circleClass:string;
    checkClass : string;
}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/ProgressBar.ts